<template>
  <div class="pushPopup">
    <!-- PUSH POPUP i.e. pushed item to be seen on active tab -->
    <transition name="pushPopup-transition"
                enter-active-class="animate-entrance"
                leave-active-class="animate-exit"
                >
      <div class="pushPopup__box position--box dimension--box" v-if="isPopupShown" @click="closePopup()" @mouseover="isHovering = true" @mouseleave="isHovering = false">
        <template v-if="pushPayloadMsg.data">
          <div class="pushPopup__closeBtn position--closeBtn dimension--closeBtn"><svg-close-popup width="15" height="15"></svg-close-popup></div>
          <component v-bind="linkProps()" class="dimension--inherit">
            <div @click="updatePushVisitedList(pushPayloadMsg.data.nid)" class="dimension--inherit">
              <div class="pushPopup__col--left dimension--left position--left">
                <template v-if="imageUrl">
                  <SpeechBalloonLabel v-if="articleType === 'live'" :node="popupNode" size="small-responsive" mainComponent="pushPopup" shadow></SpeechBalloonLabel>
                  <div class="pushPopup__image dimension--inherit" :style="{'background-image': `url('${imageUrl}')`}"></div>
                </template>
              </div>
              <div class="pushPopup__col--right dimension--right position--right">
                <p class="pushPopup__header p--header font--large">NEW ON ABACUS</p>
                <p v-if="pushPayloadMsg.data.title" class="font--small hidden-320-down">{{ pushPayloadMsg.data.title | truncateText(87) }}</p>
                <p v-if="pushPayloadMsg.data.title" class="font--small hidden-320-up">{{ pushPayloadMsg.data.title | truncateText(65) }}</p>
              </div>
            </div>
          </component>
        </template>
      </div>
    </transition>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'

import get from 'lodash/get'
import truncate from 'lodash/truncate'
import isEmpty from 'lodash/isEmpty'

import NodeLink from 'components/node/Link'
import SpeechBalloonLabel from 'components/common/SpeechBalloonLabel'

import SvgClosePopup from 'static/svg/raw/icon_close_notify.svg'

import firebasePush from 'components/mixins/firebasePush'
import mixinSection from 'components/mixins/section'
import pushVisitedList from 'components/mixins/pushVisitedList'

import { getArticleType } from 'mixins/utilities'

export default {
  name: 'widget-push-popup',
  mixins: [firebasePush, mixinSection, pushVisitedList],
  components: {
    SvgClosePopup,
    NodeLink,
    SpeechBalloonLabel,
  },
  data() {
    return {
      isPopupShown: false,
      popupNode: {},
      imageUrl: false,
      isHovering: false,
      restartTimeout: null,
    }
  },
  mounted() {
    if ('Notification' in window && Notification.permission === 'granted' && this.getLocalStorageSubscribed()) {
      // 1) So firebase can initialize the app again
      // 2) To recieve payload msg on active tab
      // 3) Situation: Granted + subscribed: To resubscribe to fcm on refresh, only if subscribed
      this.fcmTrigger()
    }
    // Note: If Granted + not subscibed: It will show the default
  },
  computed: {
    ...mapState(['pushPayloadMsg']),
    articleType() {
      return getArticleType(this.popupNode)
    },
  },
  methods: {
    ...mapActions(['setPushPayloadMsg']),
    closePopup() {
      this.isPopupShown = false
    },
    autoClosePopUp() {
      const timer = get(this, 'config.NOTIFICATION_POPUP_TIMER', 5000)
      this.restartTimeout = setTimeout(() => { this.closePopup() }, timer)
    },
    clearPopUpTimeout() {
      if (this.restartTimeout) clearTimeout(this.restartTimeout)
    },
    showPopup() {
      if (!isEmpty(get(this, 'pushPayloadMsg', {}))) {
        this.isPopupShown = true
      }
    },
    updateImageUrl(node = false) {
      const payloadImage = get(this, 'pushPayloadMsg.data.icon', false)

      if (!isEmpty(node)) {
        const nodeImage = get(node, 'images[0].style_600x600', false)

        if (nodeImage) {
          this.imageUrl = nodeImage
          return
        }
        this.imageUrl = payloadImage
        return
      }
      this.imageUrl = payloadImage
    },
    updateNodePopup() {
      const nid = get(this, 'pushPayloadMsg.data.nid', false)
      if (nid) {
        this.$store.dispatch('fetchNode', { nid }).then(() => {
          this.popupNode = this.$store.getters.node(nid)

          if (!isEmpty(get(this, 'popupNode', {}))) {
            this.updateImageUrl(this.popupNode)
            this.showPopup()
          }
        })
      }
    },
    linkProps() {
      const node = get(this, 'popupNode', {})
      const payloadLink = get(this, 'pushPayloadMsg.data.click_action', '')

      if (!isEmpty(node)) {
        const destinationTid = this.getLastSection(get(node, 'sections', []))

        if (destinationTid) {
          return {
            is: 'node-link',
            url: `${node.relative_url}`,
            type: `${node.type}`,
            nid: `${node.nid}`,
            title: `${node.title}`,
            destinationTid: `${destinationTid}`,
          }
        }
        // Fallback if no TID
        return {
          is: 'a',
          href: payloadLink,
        }
      }
      // Fallback in case node was not returned
      return {
        is: 'a',
        href: payloadLink,
      }
    },
    resetData() {
      this.setPushPayloadMsg({})
      this.popupNode = {}
      this.clearPopUpTimeout()
    },
  },
  filters: {
    truncateText: (value, length = 20) => {
      if (!isEmpty(value)) {
        return truncate(value, {length, separator: ' '})
      }
      return value
    },
  },
  watch: {
    isPopupShown(status) {
      if (status) {
        this.autoClosePopUp()
      } else {
        this.resetData()
      }
    },
    pushPayloadMsg(payload) {
      if (!isEmpty(payload)) {
        if (get(payload, 'data.nid', false)) {
          this.updateNodePopup() // Only if nid is available, update the popup details as a node
          return
        }
        this.updateImageUrl() // use payload image if no nid
        this.showPopup()
      }
    },
    isHovering(isHovering) {
      if (isHovering) {
        this.clearPopUpTimeout() // Keep pop up open on hover
        return
      }
      this.autoClosePopUp()
    },
  },
  destroyed() {
    this.resetData()
  },
}
</script>
<style lang="scss" scoped>
  //** VARIABLES
  $closeBtn-width: 30;
  $box-height-s: 100;
  $box-height-m: 120;
  $box-width-s: 345;
  $box-width-m: 420;

  //** SPECIFIC STYLE CLASSES
  a {
    cursor: pointer;
  }

  p.font--small, .font--small {
    font-family: $barlow;
    font-size: rem-calc(14);
    line-height: rem-calc(18);
    @include respond-to('desktop') {
      font-size: rem-calc(20);
      line-height: rem-calc(24);
    }
  }

  p.font--large, .font--large{
    font-size: rem-calc(16);
    line-height: rem-calc(16);
    @include respond-to('desktop') {
      font-size: rem-calc(20);
      line-height: rem-calc(20);
    }
  }

  @media (min-width: 321px) {
    .hidden-320-up {
      display: none !important;
    }
  }

  @media (max-width: 320px) {
    .hidden-320-down {
      display: none !important;
    }
  }

  .position {
    &--box {
      z-index: 1030;
      position: fixed;
      top: auto;
      right: auto;
      left: 50%;
      bottom: rem-calc(15);
      transform: translateX(-50%);
      @include respond-to(desktop) {
        top: rem-calc(70);
        right: rem-calc(10);
        left: auto;
        bottom: auto;
        transform: none;
      }
    }

    &--closeBtn {
      position: absolute;
      top: rem-calc(-$closeBtn-width);
      right: 0;
      @include respond-to(desktop) {
        top: auto;
        right: auto;
        left: rem-calc(-$closeBtn-width);
      }
    }

    &--left, &--right {
      @include respond-to(desktop) {
        float: none;
        vertical-align:top;
        overflow: hidden;
        display: inline-block;
      }
    }
    &--left {
      float: left;
    }
  }

  .dimension {
    &--closeBtn {
      width: rem-calc($closeBtn-width);
      height: rem-calc($closeBtn-width);
    }
    &--box {
      width: 92vw;
      height: rem-calc($box-height-s);
      max-width: rem-calc($box-width-s);
      overflow: visible;

      @include respond-to('desktop') {
        width: rem-calc($box-width-m);
        height: rem-calc($box-height-m);
        max-width: none;
      }
    }
    &--left {
      width: rem-calc($box-height-s); // so image is proportion
      height: inherit;

      @include respond-to('desktop') {
        width: rem-calc($box-height-m);;
      }
    }
    &--right {
      width: auto;
      height: inherit;
      overflow: hidden;

      @include respond-to('desktop') {
        width: rem-calc($box-width-m - $box-height-m);
      }
    }
    &--inherit {
      width: inherit;
      height: inherit;
    }
  }

  //** MAIN STYLING
  .pushPopup {
    &__box {
      background-color: $Platinum;
      color: $base-font-color;
      box-shadow: 0px 4px 0px 0px rgba(0,0,0,.2);

      p {
        margin: 0;
        &.p--header {
          margin-bottom: rem-calc(5);

          @include respond-to('desktop') {
            margin-bottom: rem-calc(2);
          }
        }
      }

      a, a:hover, a:active, a:focus {
        color: inherit;
        text-decoration: inherit;
      }
    }

    &__closeBtn {
      padding: rem-calc(8 7 7 8);
      background-color: $ash-grey;
      cursor: pointer;

      svg {
        vertical-align: top;
      }
    }

    &__col--right {
      padding: rem-calc(10 10 16);

      @include respond-to('desktop') {
        padding-top: rem-calc(12);
      }
    }

    &__header {
      font-family: $silkscreen;
      color: $rose;
      text-transform: uppercase;
    }

    &__image {
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
    }
  }

  //** ANIMATIONS
  $animation-timer-fuction: cubic-bezier(0.42, 0, 0.158, 1);
  .animate-entrance {
    animation:
      fadeIn .15s $animation-timer-fuction,
      slideInUpCentered .3s $animation-timer-fuction;

    animation-fill-mode: both;

    @include respond-to(desktop) {
      animation:
        fadeIn .15s $animation-timer-fuction,
        slideInRight .3s $animation-timer-fuction;
    }
  }

  .animate-exit {
    animation:
      fadeOut .3s $animation-timer-fuction,
      slideOutDownCentered .3s $animation-timer-fuction;

    animation-fill-mode: both;

    @include respond-to(desktop) {
      animation:
        fadeOut .3s $animation-timer-fuction,
        slideOutRight .3s $animation-timer-fuction;
    }
  }

  @keyframes slideInUpCentered {
    from {
      transform: translate3d(-50%, 100%, 0);
      visibility: visible;
    }

    to {
      transform: translate3d(-50%, 0, 0);
    }
  }

  @keyframes slideOutDownCentered {
    from {
      transform: translate3d(-50%, 0, 0);
    }

    to {
      visibility: hidden;
      transform: translate3d(-50%, 100%, 0);
    }
  }
</style>



// WEBPACK FOOTER //
// PushPopup.vue?662a8ed0